import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, Renderer, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';
import { InformesService } from 'app/services/informes.service';
import * as moment from 'moment';
import { DataTableDirective } from 'angular-datatables';
import { MatDialog } from '@angular/material/dialog';
import { InformacionProcedimientosComponent } from 'app/modals/informacion-procedimientos/informacion-procedimientos.component';
import { formatTime } from 'utilities/util';
import { currentDate } from '../../../../utilities/util';
@Component({
  selector: 'app-iass-seguimiento',
  templateUrl: './iass-seguimiento.component.html',
  styleUrls: ['./iass-seguimiento.component.scss']
})
export class IASSSeguimientoComponent implements OnInit, AfterViewInit,OnDestroy {
  public dtOptions;
  public fechaInicio :string;
  public fechafin :string;
  public tableOpts;
  public dtTrigger:Subject<void>;
  public fechaInicialF:string;
  public fechaFinalFormateada:string;
  @ViewChild(DataTableDirective, {static:true})
  tabla: DataTableDirective;

  constructor(private _informes:InformesService, private _renderer:Renderer2, private dialog:MatDialog) {
    this.dtTrigger = new Subject();
    this.fechaInicio = currentDate();
    this.fechafin = currentDate()
    this.dtTrigger.next();
    this.tableOpts = [];

  }

  ngOnInit() {
    this.dtOptions = {
      columns:[
        {
          title:'Tratamiento',
          render: (data, type, row, meta)=>{
            return `<a tratamiento="${data}">${data}</a>`
          }
        },
        {
          title:'numero de repeticiones',
          data:'numero_repeticiones'
        }
      ]
    }
  }

  /**
   * obternetData
   */
  public buscar() {
    const arregloInicio = formatTime(this.fechaInicio);
    const arregloFin = formatTime(this.fechafin);
    this._informes.informeTratamientos(arregloInicio, arregloFin)
      .subscribe((data:any) => {
        this.rerender();
        this.tableOpts = data.resultado;
      });
  }

  /**
   * rerender
   */
  public rerender() {
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destruimos la instancia del datatable para re renderizar la tabla
      dtInstance.destroy();
      // Disparamos el evento de el subject para que la tabla vuelva a instanciarse
      this.dtTrigger.next();
    })
  }
  ngAfterViewInit(){
    this.dtTrigger.next();

  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.dtTrigger.unsubscribe();
  }

  openModalInfo(tratamiento){
    let fechaInicial = formatTime(this.fechaInicio);
    let fechaFinal = formatTime(this.fechafin);
    this.dialog.open(InformacionProcedimientosComponent, {
      height:'75%',
      width:'75%',
      data : {
        fechaInicial,
        tratamiento,
        fechaFinal
      }
    })
  }
}
